<template>
  <div class="dramaDesktop zy_constr">
    <div class="dramaDesktop-info">
      <div class="dramaDesktop-title">运营矩阵</div>
      <div class="dramaDesktop-content">
        <div class="dramaDesktop-desc">公司持续拓展短剧内容分发与运营渠道，旗下产品包括速看短剧APP，子诗短剧、薏米短剧等小程序，早茶剧场、青柠剧场等多部抖音号，支撑短剧业务的深度拓展。</div>
      </div>
      <img class="dramaDesktop-bg" v-lazy="'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/965e1c5a-62c0-4db7-a6aa-319ede55f656.png'" alt="" >
    </div>
    <img class="dramaDesktop-img" v-lazy="'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/1ec90330-a6d7-4290-a5d1-255342551a87.png'" alt="">
  </div>
</template>

<script>
export default {
  name: 'Description',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/function.scss";

.dramaDesktop {
  padding: 0 rem(48);

}

.dramaDesktop-info {
  box-sizing: border-box;
  padding-top: rem(72);
  height: rem(260*3);
  background-color: rgba(248, 248, 250, 1);
  position: relative;
  border-radius: 16px;
  width: rem(328*3);
  overflow: hidden;
}

.dramaDesktop-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  height: rem(160*3);
}

.dramaDesktop-title {
  font-size: rem(48);
  font-weight: 500;
  color: #000;
  line-height: rem(60);
  text-align: center;
}

.dramaDesktop-content {
  padding: rem(42);
}

.dramaDesktop-desc {
  margin-top: rem(36);
  font-size: rem(36);
  color: rgba(0, 0, 0, 0.85);
  line-height: rem(54);
  &:first-child {
    margin-top: 0;
  }
}

.dramaDesktop-img {
  display: block;
  width: rem(328*3);
  margin-top: rem(72);
}

/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
    .S .dramaDesktop-title {
      font-weight: bold;
    }
}
</style>
